t = require('app/scripts/views/internal/teacup-with-helpers')('header_warning_banner')

module.exports = ->
  t.p '.u-bottom', ->
    t.mustacheBlock 'knownEmailProvider', ->
      t.format 'please-confirm-your-email-address-email-check-your-inbox', { email: t.mustacheVar('email'), emailInboxUrl: t.mustacheVar('emailInboxUrl') }
      t.a '.header-banner-link-left.quiet.js-resend-confirmation-email', { href: '#' }, ->
        t.format 'resend-email'
    t.mustacheBlockInverted 'knownEmailProvider', ->
      t.format 'please-confirm-your-email-address-email', { email: t.mustacheVar('email') }
      t.a '.header-banner-link-left.quiet.js-resend-confirmation-email', { href: '#' }, ->
        t.format 'resend-email'
